﻿import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';

const Switch = ({
  checked,
  onChange,
  disabled = false,
  label,
  id,
  className,
  size = 'default',
}) => {
  const switchId = id || `switch-${Math.random().toString(36).substring(2, 9)}`;

  const sizes = {
    sm: {
      track: 'w-8 h-4',
      thumb: 'w-3 h-3',
      translate: '16px',
    },
    default: {
      track: 'w-11 h-6',
      thumb: 'w-5 h-5',
      translate: '20px',
    },
    lg: {
      track: 'w-14 h-8',
      thumb: 'w-7 h-7',
      translate: '24px',
    },
  };

  const currentSize = sizes[size] || sizes.default;

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <button
        id={switchId}
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => !disabled && onChange(!checked)}
        className={cn(
          'relative inline-flex items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
          currentSize.track,
          checked ? 'bg-primary' : 'bg-gray-200',
          disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
        )}
      >
        <motion.span
          className={cn(
            'pointer-events-none inline-block transform rounded-full bg-white shadow ring-0',
            currentSize.thumb,
          )}
          animate={{
            x: checked ? currentSize.translate : '2px',
          }}
          transition={{
            type: 'tween',
            ease: 'easeInOut',
            duration: 0.2,
          }}
        />
      </button>
      {label && (
        <label
          htmlFor={switchId}
          className={cn(
            'text-sm font-medium',
            disabled ? 'text-gray-400' : 'text-gray-700',
            'cursor-pointer',
          )}
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default Switch;
